export default __webpack_public_path__ + "static/media/appIcon.160e1923.png";